import { SPECIALIZED_TERMINALS } from './index'

export function terminalLabel (account, slug, fallback) {
  const meta = account && account.permissions && account.permissions._meta
  const override = meta && meta.terminal_labels && meta.terminal_labels[slug]
  return override || fallback
}

export function achBatchLegLabel (account, legKey, fallback) {
  const meta = account && account.permissions && account.permissions._meta
  const override = meta && meta.ach_batch && meta.ach_batch.leg_labels && meta.ach_batch.leg_labels[legKey]
  return override || fallback
}

export function achBatchNetLabel (account, fallback) {
  const meta = account && account.permissions && account.permissions._meta
  const override = meta && meta.ach_batch && meta.ach_batch.net_label
  return override || fallback
}

export function findEntry (slug) {
  return SPECIALIZED_TERMINALS.find(t => t.slug === slug)
}



// WEBPACK FOOTER //
// ./src/components/terminal/specialized/labelFor.js